import { gql } from 'apollo-angular';

export default gql`
  mutation deleteElementType($uri: String!, $tenantUri: String!) {
    deleteElementType(uri: $uri, tenantUri: $tenantUri) {
      hasViolations
      violations {
        source
        providedValue
        description
        localisationResourceId
      }
    }
  }
`;
